<template>
  <div class="index" style="background-color: #000000">
    <header-layout/>
    <router-view />
    <footer-layout/>
  </div>
</template>

<script>
// 引入btn按钮的js
import { toggler } from "@/assets/toggler/toggler.js";
import headerLayout from "../layout/header.vue";
import footerLayout from "../layout/footer.vue";
export default {
  components: {
    headerLayout,
    footerLayout
  },
  data() {
    return {
      list: [
        {
          name: "首页",
          nickName: "home",
        },
        {
          name: "项目案例",
          nickName: "project",
        },
        {
          name: "关于我们",
          nickName: "about",
        },
        {
          name: "联系加盟",
          nickName: "contact",
        },
      ],
    };
  },
  mounted() {
    toggler();
  },
  methods: {
    // 导航路由点击触发btn的click
  },
};
</script>

<style lang="less">
@import "../assets/toggler/toggler.css";

.wrapBtn {
  position: relative;
  width: 36px;
  height: 36px;
}

// 重写btn
#btn {
  top: 0;
  left: 0;
  -webkit-transform: none;
  transform: none;
  width: 36px;
  height: 36px;
  background: none;

  span {
    width: 24px;
    height: 2px;
  }
}

// 添加其他点击样式
.active > .nav-link {
  color: rgba(119, 155, 253, 1) !important;
  // border-bottom: 4px solid  rgba(119, 155, 253);
}

// 按钮切换的样式
.navbar-light .navbar-toggler {
  color: rgba(119, 155, 253, 1);
  border-color: rgba(0, 0, 0, 0.1);
}

.index {
  .header {
    position: absolute;
    left: 0;
    right: 0;
    top: 36px;
    height: 60px;
    z-index: 10;
    padding: 0px 180px 0px 180px;

    h1 {
      font-size: 26px;
      line-height: 60px;
      font-weight: bold;
    }

    ul {
      display: flex;

      li {
        padding: 22px 26px;
        font-size: 16px;
        transition: all 0.3s;
        color: white;
        cursor: pointer;

        &:hover {
          color: @main-color;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index.vue